export const ACTIVE_USERS_MAX_DISPLAY = 5;
export const ACTIVE_USERS_POLL_INTERVAL_MS = 300_000; // 5 minutes
